// import React from 'react';

// import './index.css';
// const VideoModal = ({ isOpen, onClose, videoSrc }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//         <button className="close-button" onClick={onClose}>
//           ×
//         </button>
//         <div className="video-container">
//           <video controls>
//             <source src={videoSrc} type="video/mp4" />
//             Your browser does not support the video tag.
//           </video>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VideoModal;

import React from "react";

const VideoPopup = ({ isOpen, onClose, videoSrc }) => {
    // const [isModalOpen, setIsModalOpen] = useState(false);

    // const toggleModal = () => {
    //     setIsModalOpen(!isModalOpen);
    // };

    return (
        <div>
            {/* Modal */}
            {isOpen && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        {/* Close Button */}
                        <button style={styles.closeButton} onClick={onClose}>
                            &times;
                        </button>

                        {/* Video */}
                        <video
                            controls
                            // autoPlay
                            style={styles.video}
                        >
                            <source
                                src={videoSrc}
                                type="video/mp4"
                            />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            )}
        </div>
    );
};

// Styles
const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },
    modal: {
        position: "relative",
        width: "90%",
        maxWidth: "800px",
        background: "#000",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 4px 15px rgba(0,0,0,0.5)",
    },
    video: {
        width: "100%",
        height: "auto",
        borderRadius: "5px",
    },
    closeButton: {
        position: "absolute",
        top: "-2px",
        right: "10px",
        background: "transparent",
        border: "none",
        fontSize: "1.5rem",
        color: "#fff",
        cursor: "pointer",
    },
};

export default VideoPopup;


